<template>
  <div class="mains">
    <div class="campus">功能模块 <span>></span> 趣配音</div>
    <el-row :gutter="16">
      <el-col :span="5">
        <div class="pane side scrollbarStyle">
          <div class="side-title">教材目录</div>
          <!-- Element Tree。接口根节点只是「选择教材」占位，不展示；点 type=0 的教材加载章节。 -->
          <el-tree
            ref="books"
            :data="tree"
            node-key="id"
            highlight-current
            :props="treeProps"
            empty-text="暂无教材"
            @node-click="pickBook"
          >
            <span class="span-ellipsis" slot-scope="{ node }">
              <span :title="node.label">{{ node.label }}</span>
            </span>
          </el-tree>
        </div>
      </el-col>
      <el-col :span="19">
        <div class="pane">
          <div class="head">
            <h2>趣配音</h2>
            <div>
              <el-button size="small" :loading="trialOpening" @click="openTrial">试用范围</el-button>
              <el-button size="small" type="primary" @click="chapterOpen = true">新建章节</el-button>
            </div>
          </div>
          <div class="bar">
            <span v-if="bookId">共 {{ total }} 个章节</span>
            <span v-else>请先选择教材</span>
            <el-input v-model="keyword" size="small" placeholder="章节名称" style="width: 180px"
                      @keyup.enter.native="search"/>
            <el-button size="small" type="primary" :loading="querying" :disabled="listLoading && !querying"
                       @click="search">查询
            </el-button>
          </div>
          <div class="cards">
            <div v-for="item in chapters" :key="item.chapterId" class="card">
              <i :class="[removingId === item.chapterId ? 'el-icon-loading' : 'el-icon-close', 'card-del']"
                 title="删除章节" @click.stop="removeChapter(item)"></i>
              <div class="thumb" @click="openChapter(item)">
                <img v-if="item.coverUrl" :src="item.coverUrl" alt=""/>
              </div>
              <div class="name" @click="openChapter(item)">{{ item.title }}</div>
              <div class="meta">视频 {{ item.watchCount }} · 配音 {{ item.materialCount }}</div>
            </div>
            <div v-if="bookId && !chapters.length" class="empty">这个教材还没有章节</div>
          </div>
          <el-pagination v-if="bookId" background layout="prev, pager, next" :current-page="page" :page-size="21"
                         :total="total" @current-change="load"/>
        </div>
      </el-col>
    </el-row>
    <el-dialog title="新建章节" :visible.sync="chapterOpen" width="460px" :before-close="closeChapter">
      <el-form label-width="90px">
        <el-form-item label="章节名称">
          <el-input v-model="chapter.title"/>
        </el-form-item>
        <el-form-item label="顺序">
          <el-input-number v-model="chapter.seqnum" :min="0"/>
        </el-form-item>
        <el-form-item label="封面">
          <el-upload action="#" :show-file-list="false" accept="image/*" :http-request="uploadCover"
                     :disabled="coverUploading">
            <el-button size="small" :loading="coverUploading">上传封面</el-button>
          </el-upload>
          <img v-if="chapter.picurl" :src="chapter.picurl" class="preview" alt=""/>
          <div v-else class="hint">不上传时使用系统默认图片。</div>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button :disabled="chapterSaving" @click="chapterOpen = false">取消</el-button>
        <el-button type="primary" :loading="chapterSaving" :disabled="coverUploading"
                   @click="addChapter">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="试用范围" :visible.sync="trialOpen" width="560px" :before-close="closeTrial">
      <p class="note">
        按章节展开。勾选章节会选中它下面的全部配音素材。这里只标记趣配音素材，要真正试用，还得在模块权限里打开趣配音的试用开关。</p>
      <!-- show-checkbox + default-expand-all：父节点是章节，子节点是素材，父子勾选联动。 -->
      <el-tree
        v-if="trialOpen && trialTree.length"
        ref="trialTree"
        class="trial-tree"
        :data="trialTree"
        show-checkbox
        node-key="id"
        default-expand-all
        :expand-on-click-node="false"
        check-on-click-node
        :default-checked-keys="trialIds"
        :props="treeProps"
      />
      <div v-else class="empty">还没有配音素材</div>
      <span slot="footer">
        <el-button :disabled="trialSaving" @click="trialOpen = false">取消</el-button>
        <el-button type="primary" :loading="trialSaving" @click="saveTrial">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/** 趣配音章节宫格。从视频页返回时保留当前教材。 */
export default {
  name: 'dubbing',
  data() {
    return {
      tree: [],
      treeProps: {label: 'label', children: 'children'},
      bookId: '',
      keyword: '',
      chapters: [],
      total: 0,
      page: 1,
      chapterOpen: false,
      chapter: {title: '', seqnum: 0, picurl: ''},
      trialOpen: false,
      trialTree: [],
      trialIds: [],
      /** 章节列表请求中。 */
      listLoading: false,
      /** 只有点「查询」才让这个按钮转圈。 */
      querying: false,
      loadSeq: 0,
      trialOpening: false,
      trialSaving: false,
      chapterSaving: false,
      coverUploading: false,
      /** 正在删除的章节，图标改成转圈。 */
      removingId: null,
    };
  },
  created() {
    const raw = this.$route.query.bookId;
    this.bookId = raw === undefined || raw === '' ? '' : (Number.isNaN(Number(raw)) ? raw : Number(raw));
    this.keyword = this.$route.query.keyword || '';
    this.page = Number(this.$route.query.page) || 1;
    this.loadTree();
  },
  methods: {
    auth() {
      return {Authorization: 'Bearer ' + window.sessionStorage.getItem('userinfo').replace(/"/g, '')};
    },
    loadTree() {
      const orgid = window.sessionStorage.getItem('orgid');
      this.$http({url: '/edu/book/getGroupTree/' + orgid, method: 'GET', headers: this.auth()}).then((res) => {
        if (res.data.code !== 0) return this.$message.error(res.data.message);
        this.tree = this.bookNodes(res.data.data || []);
        this.$nextTick(() => {
          if (this.bookId && this.$refs.books) this.$refs.books.setCurrentKey(this.bookId);
        });
        if (this.bookId) this.load(this.page);
      });
    },
    /** 去掉接口包的「选择教材」根节点，树从教材分组开始。 */
    bookNodes(nodes) {
      if (nodes.length === 1 && (nodes[0].id === 0 || nodes[0].label === '选择教材')) return nodes[0].children || [];
      return nodes;
    },
    pickBook(node) {
      if (!node || node.type !== 0) return;
      this.bookId = node.id;
      this.load(1);
    },
    /** 查询按钮。点下去立刻转圈，列表还在请求时忽略下一次。 */
    search() {
      if (this.querying || this.listLoading) return;
      if (!this.bookId) return this.load(1);
      this.querying = true;
      this.load(1).then(() => {
        this.querying = false;
      }, () => {
        this.querying = false;
      });
    },
    load(page) {
      if (!this.bookId) return Promise.resolve();
      const seq = ++this.loadSeq;
      this.listLoading = true;
      this.page = page;
      return this.$http({
        url: '/edu/dubbing/chapters', method: 'GET', headers: this.auth(),
        params: {bookId: this.bookId, title: this.keyword, page, pageSize: 21},
      }).then((res) => {
        if (seq !== this.loadSeq) return;
        if (res.data.code !== 0) return this.$message.error(res.data.message);
        this.chapters = res.data.data.records || [];
        this.total = res.data.data.total || 0;
      }).then(() => {
        if (seq === this.loadSeq) this.listLoading = false;
      }, () => {
        if (seq === this.loadSeq) this.listLoading = false;
      });
    },
    openChapter(item) {
      this.$router.push({
        name: 'dubbingVideos',
        query: {
          bookId: this.bookId,
          chapterId: item.chapterId,
          title: item.title,
          seqnum: item.seqnum || 0,
          cover: item.coverUrl || '',
          page: this.page,
          keyword: this.keyword
        },
      });
    },
    uploadCover(data) {
      if (this.coverUploading) return;
      this.coverUploading = true;
      const form = new FormData();
      form.append('file', data.file);
      form.append('orgid', window.sessionStorage.getItem('orgid'));
      this.$http({url: '/mini/miniInfo/uploadimage', method: 'POST', data: form, headers: this.auth()}).then((res) => {
        if (res.data.code !== 0) return this.$message.error(res.data.message);
        this.chapter.picurl = res.data.data;
      }).then(() => {
        this.coverUploading = false;
      }, () => {
        this.coverUploading = false;
      });
    },
    closeChapter(done) {
      if (this.chapterSaving || this.coverUploading) return;
      done();
    },
    /** 只把章节标为无效。视频、配音素材都不删。 */
    removeChapter(item) {
      if (this.removingId) return;
      this.removingId = item.chapterId;
      const tip = '只隐藏这个章节，下面的视频和配音都会保留。';
      const clear = () => {
        this.removingId = null;
      };
      this.$confirm(tip, '删除章节', {type: 'warning'}).then(() => {
        return this.$http({
          url: '/edu/chapterandsection/deleteChapterandsection/' + item.chapterId,
          method: 'POST',
          headers: this.auth(),
        }).then((res) => {
          if (res.data.code !== 0) return this.$message.error(res.data.message);
          this.$message.success('章节已删除');
          const page = this.chapters.length === 1 && this.page > 1 ? this.page - 1 : this.page;
          return this.load(page);
        });
      }).catch(() => {
      }).then(clear, clear);
    },
    addChapter() {
      if (this.chapterSaving || this.coverUploading) return;
      if (!this.bookId || !this.chapter.title) return this.$message.error('请填写章节名称');
      this.chapterSaving = true;
      this.$http({
        url: '/edu/chapterandsection/addChapterandsection', method: 'POST', headers: this.auth(),
        data: {
          orgid: window.sessionStorage.getItem('orgid'),
          bookid: this.bookId,
          title: this.chapter.title,
          seqnum: this.chapter.seqnum,
          picurl: this.chapter.picurl
        },
      }).then((res) => {
        if (res.data.code !== 0) return this.$message.error(res.data.message);
        this.chapterOpen = false;
        this.chapter = {title: '', seqnum: 0, picurl: ''};
        return this.load(1);
      }).then(() => {
        this.chapterSaving = false;
      }, () => {
        this.chapterSaving = false;
      });
    },
    /** 章节接口单页最多 50 条，翻页拼出整本教材，用来给素材补章节名。 */
    fetchChapters(page, acc) {
      const pageSize = 50;
      return this.$http({
        url: '/edu/dubbing/chapters', method: 'GET', headers: this.auth(),
        params: {bookId: this.bookId, page, pageSize},
      }).then((res) => {
        if (res.data.code !== 0) throw new Error(res.data.message);
        const data = res.data.data || {};
        const records = data.records || [];
        const all = acc.concat(records);
        if (records.length && all.length < (data.total || 0)) return this.fetchChapters(page + 1, all);
        return all;
      });
    },
    /** 章节做父节点，配音素材做子节点。已有 chapterTitle 时直接用，否则用章节列表补名称。 */
    buildTrialTree(materials, chapters) {
      const titleOf = {};
      const order = [];
      (chapters || []).forEach((chapter) => {
        titleOf[chapter.chapterId] = chapter.title;
        order.push(chapter.chapterId);
      });
      const byChapter = {};
      (materials || []).forEach((item) => {
        const chapterId = item.chapterId;
        if (!byChapter[chapterId]) {
          byChapter[chapterId] = {
            id: 'chapter-' + chapterId,
            label: item.chapterTitle || titleOf[chapterId] || ('章节 ' + chapterId),
            children: [],
          };
          if (order.indexOf(chapterId) < 0 && order.indexOf(Number(chapterId)) < 0) order.push(chapterId);
        }
        byChapter[chapterId].children.push({
          id: item.materialId,
          materialId: item.materialId,
          label: (item.title || '未命名') + ' · ' + this.statusText(item.status),
        });
      });
      return order.filter((id) => byChapter[id]).map((id) => byChapter[id]);
    },
    openTrial() {
      if (this.trialOpening) return;
      if (!this.bookId) return this.$message.warning('请先选择教材');
      this.trialOpening = true;
      const materialsReq = this.$http({
        url: '/edu/dubbing/materials', method: 'GET', headers: this.auth(), params: {bookId: this.bookId},
      });
      Promise.all([materialsReq, this.fetchChapters(1, [])]).then(([res, chapters]) => {
        if (res.data.code !== 0) return this.$message.error(res.data.message);
        const materials = res.data.data || [];
        this.trialTree = this.buildTrialTree(materials, chapters);
        this.trialIds = materials.filter((item) => item.trialFlag === 1 || item.trialFlag === true).map((item) => item.materialId);
        this.trialOpen = true;
      }).catch((err) => {
        this.$message.error(err.message || '查询试用范围失败');
      }).then(() => {
        this.trialOpening = false;
      });
    },
    closeTrial(done) {
      if (this.trialSaving) return;
      done();
    },
    saveTrial() {
      if (this.trialSaving) return;
      if (!this.trialTree.length) {
        this.trialOpen = false;
        return;
      }
      this.trialSaving = true;
      const nodes = this.$refs.trialTree ? this.$refs.trialTree.getCheckedNodes(true) : [];
      const materialIds = nodes.map((node) => node.materialId).filter((id) => id != null);
      this.$http({
        url: '/edu/dubbing/trial', method: 'POST', headers: this.auth(),
        data: {bookId: this.bookId, materialIds},
      }).then((res) => {
        if (res.data.code !== 0) return this.$message.error(res.data.message);
        this.trialOpen = false;
        this.$message.success('试用范围已保存');
      }).then(() => {
        this.trialSaving = false;
      }, () => {
        this.trialSaving = false;
      });
    },
    statusText(status) {
      return {DRAFT: '草稿', PUBLISHED: '已上架', OFFLINE: '已下架'}[status] || status;
    },
  },
};
</script>

<style scoped>
.pane {
  background: #fff;
  padding: 12px;
  min-height: 70vh;
}

.side {
  background: #fff;
  max-height: 85vh;
  overflow: auto;
}

.side-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  padding-left: 8px;
  margin-bottom: 8px;
}

.side ::v-deep .span-ellipsis {
  display: inline-block;
  max-width: 180px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  vertical-align: middle;
}

.head {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.head h2 {
  margin: 0;
  font-size: 20px;
}

.bar {
  margin: 12px 0;
}

.bar > * {
  margin-right: 8px;
}

.cards {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.card {
  position: relative;
  width: 132px;
  border-radius: 8px;
  padding: 8px 8px 10px;
  background: #fff;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.12);
  text-align: center;
}

.thumb, .name {
  cursor: pointer;
}

.card img {
  width: 116px;
  height: 84px;
  object-fit: contain;
  background: #fff;
  border-radius: 6px;
  display: block;
  margin: 0 auto;
}

.name {
  margin-top: 6px;
  font-size: 13px;
  font-weight: 600;
  color: #333;
  word-break: break-all;
}

.meta, .note, .empty, .hint {
  color: #888;
  font-size: 12px;
}

.card-del {
  position: absolute;
  top: 4px;
  right: 4px;
  width: 18px;
  height: 18px;
  line-height: 18px;
  text-align: center;
  color: #999;
  font-size: 14px;
  cursor: pointer;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.92);
}

.card-del:hover {
  color: #f56c6c;
}

.preview {
  width: 120px;
  height: 140px;
  object-fit: contain;
  margin-top: 8px;
  display: block;
}

.trial-tree {
  max-height: 360px;
  overflow: auto;
  border: 1px solid #e6e6e6;
  border-radius: 8px;
  padding: 8px 4px;
}
</style>
